document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById("product-grid");
  const sortBySelect = document.getElementById("SortBy"); // Sorting dropdown

  if (!productGrid) {
    console.error("Product grid element not found.");
    return;
  }

  if (!sortBySelect) {
    console.error("SortBy select element not found.");
    return;
  }

  // Get the currently selected sorting option
  const selectedOption = sortBySelect.options[sortBySelect.selectedIndex];

  if (!selectedOption) {
    console.error("No selected option found in SortBy dropdown.");
    return;
  }

  const sortBy = selectedOption.value;
  console.log(`Current sorting method: ${sortBy}`);

  // Apply custom sorting only for price ascending or price descending
  if (sortBy !== "price-ascending" && sortBy !== "price-descending") {
    console.log("Default Shopify sorting is applied.");
    return;
  }

  const products = Array.from(productGrid.children);

  if (!products.length) {
    console.warn("No products found in the product grid.");
    return;
  }

  // Sort products based on the selected sorting method
  products.sort((a, b) => {
    const priceA = parseFloat(a.getAttribute("data-price")) || 0;
    const priceB = parseFloat(b.getAttribute("data-price")) || 0;
    const titleA = (a.getAttribute("data-title") || "").toLowerCase();
    const titleB = (b.getAttribute("data-title") || "").toLowerCase();

    if (sortBy === "price-ascending") {
      // Sort by price ascending, then alphabetically
      return priceA !== priceB ? priceA - priceB : titleA.localeCompare(titleB);
    } else if (sortBy === "price-descending") {
      // Sort by price descending, then alphabetically
      return priceB !== priceA ? priceB - priceA : titleA.localeCompare(titleB);
    }
  });

  // Reorder products in the DOM
  const fragment = document.createDocumentFragment();
  products.forEach((product) => fragment.appendChild(product));
  productGrid.appendChild(fragment);

  console.log(`Products sorted by: ${sortBy}`);
});
